"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Accordion = /** @class */ (function () {
    function Accordion(element, args) {
        if (args === void 0) { args = {}; }
        var _this = this;
        if (!(element instanceof HTMLElement)) {
            throw new TypeError('Invalid element');
        }
        this.eventType = args.eventType || 'click';
        this.container = element;
        this.items = Array.from(element.querySelectorAll('.accordion__item'));
        this.active = null;
        this.changeEvent = new Event('accordion:changed');
        this.container.accordion = this;
        this.items.forEach(function (item) {
            item.classList.add('closed');
            var heading = item.querySelector('.accordion__heading');
            if (heading !== null) {
                heading.addEventListener(_this.eventType, function (ev) {
                    _this.open(ev.target.closest('.accordion__item'));
                });
            }
        });
        this.open(element.querySelectorAll('.accordion__item')[0]);
        this.container.dispatchEvent(this.changeEvent);
        window.addEventListener('resize', function () { return _this.resize(); }, {
            passive: true,
        });
        this.resize();
        return this;
    }
    Accordion.prototype.toggle = function (item) {
        if (this.items.indexOf(item) === -1) {
            return false;
        }
        var open = (this.active !== item);
        item.classList.toggle('closed', !open);
        var copy = item.querySelector('.accordion__content');
        if (!copy) {
            return false;
        }
        copy.style.height = 'auto';
        if (this.active && open) {
            this.close(this.active, true);
        }
        this.active = open ? item : null;
        this.container.dispatchEvent(this.changeEvent);
        return true;
    };
    Accordion.prototype.open = function (item) {
        if (this.items.indexOf(item) === -1) {
            return false;
        }
        if (this.active === item) {
            return true;
        }
        var copy = item.querySelector('.accordion__content');
        if (!copy) {
            return false;
        }
        copy.style.height = 'auto';
        item.classList.remove('closed');
        if (this.active) {
            this.close(this.active, true);
        }
        this.active = item;
        this.container.dispatchEvent(this.changeEvent);
        return true;
    };
    Accordion.prototype.close = function (item, suppressEvent) {
        if (suppressEvent === void 0) { suppressEvent = false; }
        if (this.items.indexOf(item) === -1) {
            return false;
        }
        if (this.active !== item) {
            return true;
        }
        this.active.classList.add('closed');
        this.active = null;
        if (!suppressEvent) {
            this.container.dispatchEvent(this.changeEvent);
        }
        return true;
    };
    Accordion.prototype.resize = function () {
        var _this = this;
        this.items.forEach(function (item) {
            var copy = item.querySelector('.accordion__content');
            if (!copy) {
                return;
            }
            item.classList.remove('closed');
            copy.style.height = 'auto';
            if (_this.active !== item) {
                item.classList.add('closed');
            }
        });
    };
    return Accordion;
}());
var AccordionComponents = /** @class */ (function () {
    function AccordionComponents() {
        var _a;
        var accordions = Array.from((_a = document.querySelectorAll('[data-accordion]')) !== null && _a !== void 0 ? _a : []);
        accordions.forEach(function (accordion) { return new Accordion(accordion); });
    }
    return AccordionComponents;
}());
exports.default = AccordionComponents;
